import { Component } from '@angular/core';

/**
 * Page wrapper for the main issues list view.
 * Enables filter persistence with a dedicated storage key.
 */
@Component({
  selector: 'app-issues-page',
  template: `
    <app-issue-list 
      filterStorageKey="issues-page-filters">
    </app-issue-list>
  `
})
export class IssuesPageComponent {}
